var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42.701,
    height: 42.701,
    viewBox: "0 0 42.701 42.701",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M13.752 2.05343C13.1099 0.502258 11.417 -0.323365 9.79906 0.118635C9.79906 0.118635 2.46019 2.12015 2.46019 2.12015C1.0091 2.52045 0 3.83811 0 5.33924C0 25.9715 16.7293 42.7008 37.3615 42.7008C38.8627 42.7008 40.1803 41.6917 40.5806 40.2406C40.5806 40.2406 42.5821 32.9017 42.5821 32.9017C43.0241 31.2838 42.1985 29.5909 40.6474 28.9487C40.6474 28.9487 32.6413 25.6129 32.6413 25.6129C31.2819 25.0458 29.7058 25.4377 28.7801 26.5803C28.7801 26.5803 25.4109 30.6917 25.4109 30.6917C19.5398 27.9146 14.7862 23.161 12.0091 17.2899C12.0091 17.2899 16.1205 13.9291 16.1205 13.9291C17.263 12.995 17.655 11.4272 17.0879 10.0678C17.0879 10.0678 13.752 2.06177 13.752 2.06177C13.752 2.06177 13.752 2.05343 13.752 2.05343Z",
    fill: "#45663B",
    fillRule: "evenodd",
    transform: "translate(0 -0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9a72bdad800db8834d94a72c77de765f.svg";
export { ForwardRef as ReactComponent };